import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rgba } from 'polished';

import Colours from '../definitions/Colours';
import Button from './Button';


const RejectButton = styled(Button)`
    ${props => !props.disabled && (props.variant === 'primary' || !props.variant) && `
        background-color: ${Colours.STRAWBERRY};
        border-color: ${Colours.STRAWBERRY};
        color: ${Colours.COCONUT};

        &:hover,
        &:focus {
            background-color: ${Colours.TRANSPARENT};
            border-color: ${Colours.STRAWBERRY};
            color: ${Colours.STRAWBERRY};
        }

        &:active {
            background-color: ${rgba(Colours.STRAWBERRY_DARK, 0.05)};
            border-color: ${Colours.STRAWBERRY};
            color: ${Colours.STRAWBERRY};
        }
    `}

    ${props => !props.disabled && props.variant === 'alternate' && `
        border-color: ${Colours.STRAWBERRY};
        color: ${Colours.STRAWBERRY};

        &:hover,
        &:focus {
            background-color: ${Colours.STRAWBERRY};
            border-color: ${Colours.STRAWBERRY};
            color: ${Colours.COCONUT};
        }

        &:active {
            background-color: ${Colours.STRAWBERRY_DARK};
            border-color: ${Colours.STRAWBERRY_DARK};
            color: ${Colours.COCONUT};
        }
    `}

    ${props => props.disabled && `
        cursor: default;

        border-color: ${Colours.STONE};
        background-color: ${props.variant === 'primary'
        ? Colours.STONE
        : Colours.TRANSPARENT};
        color: ${props.variant === 'primary'
        ? Colours.COCONUT
        : Colours.STONE};
    `}
`;

RejectButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    variant: PropTypes.oneOf([
        'primary',
        'alternate',
    ]),
    size: PropTypes.oneOf([ // Used within Button component
        'large',
        'medium',
        'small',
    ]),
    disabled: PropTypes.bool,
};

export default RejectButton;
